import { Identified } from "@/types/sdk-types";
import { useQuery } from "@tanstack/react-query";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";
import { PatientOrderControllerApi, PatientOrder } from "../../../services";

/**
 *
 * @author [Atish Bagate]
 */
interface GetPatientOrderByIdProps {
  patientOrderId: string;
}

export function useGetPatientOrderById({
  patientOrderId,
}: GetPatientOrderByIdProps): useBaseContent<Identified<PatientOrder>> {
  return useQuery({
    queryKey: ["Get-patient-order-by-id", patientOrderId],
    enabled: !!patientOrderId,
    queryFn: async () =>
      new PatientOrderControllerApi(getConfigObject())
        .getPatientOrderById(patientOrderId, getXtenantId())
        .then((it) => it?.data),
  });
}
